import { DeviceWithoutGatewayFormDataModel } from '../models';
import { getInitialGeneralFormValues } from './generalValues';
import { getInitialSensorValues } from './sensorValues';

export const getInitialFormValues = (): DeviceWithoutGatewayFormDataModel[] => {
  const generalFormValues = getInitialGeneralFormValues();
  const sensorFormValues = getInitialSensorValues();

  return [...generalFormValues, ...sensorFormValues];
};
